import axios from 'axios'

export default {
  // Admin buyer management methods
  fetchAdminBuyers(params) {
    return axios.get('/api/admin/buyers', { params })
  },
  createBuyer(data) {
    return axios.post('/api/admin/buyers', data)
  },
  importBuyers(formData) {
    return axios.post('/api/admin/buyers/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  // Import status checking removed - handled via email notification
  exportBuyers(data) {
    return axios.post('/api/admin/buyers/export', data)
  },
  downloadBuyerTemplate() {
    return axios.get('/api/admin/buyers/template', {
      responseType: 'blob'
    })
  },
  bulkDeleteBuyers(ids) {
    return axios.delete('/api/admin/buyers/bulk-delete', {
      data: { ids }
    })
  },
  
  deleteBuyers(ids) {
    return axios.delete('/api/admin/buyers/bulk-delete', {
      data: { ids }
    })
  },
  
  // Column management for buyer table
  getBuyerColumns() {
    return axios.get('/api/admin/buyers/columns')
  },
  updateBuyerColumn(name) {
    return axios.post('/api/admin/buyers/columns/update', { name })
  },
  updateBuyerColumnOrder(orderedColumns) {
    return axios.post('/api/admin/buyers/columns/update-order', { ordered_columns: orderedColumns })
  },
  
  // Update buyer's company
  updateBuyerCompany(buyerId, companyId) {
    return axios.patch(`/api/admin/buyers/${buyerId}/company`, { company_id: companyId })
  },

  // Recipient typeahead for the email modals. `context` decides which sources the server
  // draws on, so the caller never needs role or flow logic. A caller-supplied cancelToken
  // opts each keystroke out of the global cancel-on-route-change so it can cancel the
  // previous one instead (see plugins/axios.js, which also keeps this URL silent on error).
  searchRecipients(context, q, cancelToken) {
    return axios.get('/api/buyer/recipient-search', { params: { context, q }, cancelToken })
  }
}